import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { LocalePicker } from '@/components/locale-picker'
import PageHeader from '@/components/molecules/page-header'
import { DeleteIndividualDialog } from '@/components/organisms/delete-individual-dialog'
import { SubscriptionSettings } from '@/components/organisms/subscription-settings'
import { Separator } from '@/components/ui/separator'
import { Switch } from '@/components/ui/switch'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { SettingsActions } from '@/redux/reducers/settings'

const SettingsPage = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const featureAcronymTooltips = useAppSelector(state => state.settings.featureAcronymTooltips)

  return (
    <div className="space-y-10">
      <SubscriptionSettings />

      <Separator orientation="horizontal" />

      <div className="space-y-10">
        <PageHeader
          body={t('settingsPage.changeLanguage.description')}
          heading={t('settingsPage.changeLanguage.title')}
        >
          <LocalePicker />
        </PageHeader>

        <PageHeader
          body={t('settingsPage.toggleAcronymTooltips.description')}
          heading={t('settingsPage.toggleAcronymTooltips.title')}
        >
          <Switch
            checked={featureAcronymTooltips}
            onCheckedChange={() => dispatch(SettingsActions.toggleAcronymTooltips())}
          />
        </PageHeader>
      </div>

      <Separator orientation="horizontal" />

      <PageHeader
        body={t('dialogs.deleteIndividual.description')}
        heading={t('dialogs.deleteIndividual.title')}
      >
        <DeleteIndividualDialog />
      </PageHeader>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsPage,
})
